module.exports = __webpack_public_path__ + "img/bag_bg.5896f11e.png";